import { useState, useEffect, useRef } from '@wordpress/element';
import { setCurrentUtterance, getCurrentUtterance } from './speechManager';
import classNames from 'classnames';
import styles from './style.css';

const TextToSpeech = ({ postContent }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1);
  const [speechSynthesis] = useState(window.speechSynthesis);
  const utteranceRef = useRef(null);

  useEffect(() => {
    const text = postContent.innerText;
    const newUtterance = new SpeechSynthesisUtterance(text);
    newUtterance.rate = playbackRate;
    utteranceRef.current = newUtterance;

    const handleEnd = () => {
      setIsPlaying(false);
      setIsPaused(false);
    };

    newUtterance.addEventListener('end', handleEnd);

    return () => {
      newUtterance.removeEventListener('end', handleEnd);
    };
  }, [postContent, playbackRate]);

  useEffect(() => {
    const handlePageHide = () => {
      if (speechSynthesis.speaking) {
        speechSynthesis.cancel();
      }
    };

    window.addEventListener('pagehide', handlePageHide);

    return () => {
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [speechSynthesis]);

  const handlePlayPause = () => {
    if (!isPlaying && !isPaused) {
      if (utteranceRef.current) {
        setCurrentUtterance(utteranceRef.current);
        speechSynthesis.speak(utteranceRef.current);
        setIsPlaying(true);
      }
    } else if (isPaused) {
      speechSynthesis.resume();
      setIsPlaying(true);
      setIsPaused(false);
    } else {
      speechSynthesis.pause();
      setIsPlaying(false);
      setIsPaused(true);
    }
  };

  const handleRateChange = (event) => {
    const newRate = parseFloat(event.target.value);
    setPlaybackRate(newRate);
    if (speechSynthesis.speaking && utteranceRef.current) {
      utteranceRef.current.rate = newRate;
      // To apply the rate change immediately, pause and resume speaking
      speechSynthesis.cancel();
      setTimeout(() => {
        speechSynthesis.speak(utteranceRef.current);
      }, 0);
    }
  };

  useEffect(() => {
    const currentUtterance = getCurrentUtterance();
    if (currentUtterance && currentUtterance !== utteranceRef.current) {
      setIsPlaying(false);
      setIsPaused(false);
    }
  }, [isPlaying]);

  return (
    <div className="text-to-speech">
      <button
        className={classNames({
          playing: isPlaying,
          play: !isPlaying
        }, 'play-button')}
        onClick={handlePlayPause}
      >
        <span className="icon"></span> {isPlaying ? 'Vorlesen pausieren' : 'Beitrag vorlesen'}
      </button>
      <label>
        Geschwindigkeit:
        <select value={playbackRate}
                className={classNames('bg-transparent text-current px-1')}
                onChange={handleRateChange}>
          <option value="0.25">0.25x</option>
          <option value="0.5">0.5x</option>
          <option value="0.75">0.75x</option>
          <option value="1">1x</option>
          <option value="1.25">1.25x</option>
          <option value="1.5">1.5x</option>
          <option value="1.75">1.75x</option>
        </select>
      </label>
    </div>
  );
};

export default TextToSpeech;
